import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { Publishset } from '../../publishsets/components/Publishset';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejPublishsetDetailPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='Publishsets'
          action='retrieve'
        >
          <Publishset />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejPublishsetDetailPage;
